"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _colors = require("HubStyleTokens/colors");

var _default = {
  'candy-apple': _colors.CANDY_APPLE_MEDIUM,
  calypso: _colors.CALYPSO_MEDIUM,
  koala: _colors.KOALA,
  lorax: _colors.LORAX_MEDIUM,
  marigold: _colors.MARIGOLD_MEDIUM,
  norman: _colors.NORMAN_MEDIUM,
  oz: _colors.OZ_MEDIUM,
  sorbet: _colors.SORBET_MEDIUM,
  thunderdome: _colors.THUNDERDOME_MEDIUM
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/core/MediumColors.js
// module id = 738
// module chunks = 209 210 211 212